import { rankingData } from '@/mocks/homeData';

const rankColors: Record<number, string> = {
  1: 'bg-primary-500 text-white',
  2: 'bg-accent-500 text-white',
  3: 'bg-secondary-500 text-white',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-xs font-medium tracking-widest uppercase text-accent-600 bg-accent-100 px-3 py-1 rounded-full">
            <i className="ri-fire-line"></i>实时热榜
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mt-4">
            爆料热榜
          </h2>
          <p className="text-sm text-foreground-600 mt-2">实时更新，热度每10分钟刷新一次</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {rankingData.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 bg-background-50 rounded-lg p-4 border border-background-200/70 hover:border-primary-200 transition-colors duration-200 cursor-pointer group"
            >
              <div
                className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                  rankColors[item.rank] || 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </p>
              </div>
              <span
                className={`text-xs font-bold px-2 py-1 rounded-full flex-shrink-0 ${
                  item.tag === '爆'
                    ? 'bg-primary-100 text-primary-600'
                    : item.tag === '热'
                      ? 'bg-accent-100 text-accent-600'
                      : 'bg-secondary-100 text-secondary-600'
                }`}
              >
                {item.tag}
              </span>
              <span className="text-xs text-foreground-500 flex-shrink-0 w-16 text-right">
                {item.hot}热度
              </span>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#updates"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer"
          >
            查看更多快讯 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}